type Subscriber = (displayLoadingCard?: string) => void;

class GlobalLoadingCard {
    private subscribers: Set<Subscriber> = new Set();
    private displayLoadingCard?: string = undefined;

    private notify(): void {
        this.subscribers.forEach(fn => fn(this.displayLoadingCard));
    }

    public subscribe(fn: Subscriber): () => void {
        this.subscribers.add(fn);
        fn(this.displayLoadingCard);
        
        return () => this.subscribers.delete(fn);
    }

    public setDisplayLoadingCard(
        title?: string
    ) {
        this.displayLoadingCard = title;
        this.notify();
    }
}

export const globalLoadingCard = new GlobalLoadingCard();